export const MULTICITY_CALENDAR_HEADER_TITLE =
  "Select the outbound date for your flight from";
export const MAX_NUM_MULTICITY_ROUTES = 5;
export const ADD_FLIGHT_BUTTON_TEXT = "+ Add Flight";
export const INCOMPLETE_SEARCH_VALUES_WARNING =
  "Please complete all required fields.";
export const MAX_ROUTES_WARNING =
  "You’ve reached the maximum number of multi-city flights on a single booking.";
